import React, { useState, useEffect, useRef } from 'react';
import { GoogleMap, LoadScriptNext, Marker } from '@react-google-maps/api';
import {GlobeAmericasIcon, MapIcon} from "@heroicons/react/24/outline";
import { useDarkMode } from "../../contexts/darkModeContext";

import { ReactComponent as PFC } from "../../customIcons/PFC.svg";
import { ReactComponent as TANK } from "../../customIcons/Tanks4.svg";
import { ReactComponent as BARN } from "../../customIcons/Barn.svg";
import { ReactComponent as FIELD } from "../../customIcons/Field.svg";


import {Button, Dialog, DialogBackdrop, DialogPanel, DialogTitle, Input, Select} from "@headlessui/react";

const SmallMap = ({ address, customerMarkers, setCustomerMarkers }) => {
    const { darkMode } = useDarkMode();
    const [center, setCenter] = useState(null);
    const mapRef = useRef(null);
    const [mapReady, setMapReady] = useState(false);
    const [shouldRenderMarkers, setShouldRenderMarkers] = useState(false);

    const [dialogOpen, setDialogOpen] = useState(false);
    const [newMarkerPosition, setNewMarkerPosition] = useState(null);
    const [newMarkerLabel, setNewMarkerLabel] = useState('');
    const [newMarkerType, setNewMarkerType] = useState('Tank');
    const [newMarkerMax, setNewMarkerMax] = useState(0);
    const [newMarkerUnit, setNewMarkerUnit] = useState('');

    const geocodeAddress = async (address) => {
        const apiKey = 'AIzaSyDxrbk0CKmZUpJ-5eQGaxHH-I5lYeWrPfc';
        const url = `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(address)}&key=${apiKey}`;

        try {
            const response = await fetch(url);
            const data = await response.json();

            if (data.status === 'OK') {
                console.log("Geocoded address:", data.results[0].geometry.location);
                return data.results[0].geometry.location;
            } else {
                console.error('Geocoding error:', data.status);
                return null;
            }
        } catch (error) {
            console.error('Error fetching geocode:', error);
            return null;
        }
    };

    useEffect(() => {
        if (address) {
            setCenter(null);
            const fetchCoordinates = async () => {
                const coordinates = await geocodeAddress(address);
                if (coordinates && typeof coordinates.lat === 'number' && typeof coordinates.lng === 'number') {
                    setCenter({ lat: coordinates.lat, lng: coordinates.lng });
                    if (mapRef.current) {
                        console.log("Panning to new center:", coordinates);
                        mapRef.current.panTo({ lat: coordinates.lat, lng: coordinates.lng });
                    }
                }
            };
            fetchCoordinates();
        }
    }, [address]);

    const handleLoad = (map) => {
      console.log("Map loaded");
      mapRef.current = map;
      setMapReady(true); // ✅
      console.log("Initial customerMarkers on load:", customerMarkers);
    };

    const handleMapClick = (event) => {
        const lat = event.latLng.lat();
        const lng = event.latLng.lng();
        setNewMarkerPosition({ lat, lng });
        setDialogOpen(true);
    };

    // const handleSaveMarker = () => {
    //     if (newMarkerLabel && newMarkerType && newMarkerPosition) {
    //         const newMarker = {
    //             position: newMarkerPosition,
    //             label: `${newMarkerLabel}`,
    //             type: newMarkerType,
    //             max: parseFloat(newMarkerMax),
    //             unit: newMarkerUnit,
    //         };
    //         setCustomerMarkers((prev) => [...prev, newMarker]);
    //         setDialogOpen(false);
    //         setNewMarkerLabel('');
    //         setNewMarkerType('');
    //         setNewMarkerPosition(null);
    //         setNewMarkerUnit(``);
    //         setNewMarkerMax(0);
    //     }
    // };
    
    
    const handleSaveMarker = () => {
    console.log("handleSaveMarker called");

    console.log("Current marker values:", {
        newMarkerLabel,
        newMarkerType,
        newMarkerPosition,
        newMarkerMax,
        newMarkerUnit,
    });

    if (newMarkerLabel && newMarkerType && newMarkerPosition) {
        const newMarker = {
            position: newMarkerPosition,
            label: `${newMarkerLabel}`,
            type: newMarkerType,
            max: parseFloat(newMarkerMax),
            unit: newMarkerUnit,
        };

        console.log("Creating new marker:", newMarker);

        setCustomerMarkers((prev) => {
            const updated = [...prev, newMarker];
            console.log("Updated customer markers:", updated);
            return updated;
        });

        console.log("Closing dialog and resetting marker inputs...");
        setDialogOpen(false);
        setNewMarkerLabel('');
        setNewMarkerType('');
        setNewMarkerPosition(null);
        setNewMarkerUnit('');
        setNewMarkerMax(0);

        console.log("Marker inputs reset");
    } else {
        console.warn("Missing required marker data. Save aborted.");
    }
};

    const containerStyle = {
        width: '100%',
        height: '400px',
    };

    // 🔍 Debug customerMarkers on every update
    useEffect(() => {
        console.log("customerMarkers updated:", customerMarkers);
    }, [customerMarkers]);

    useEffect(() => {
        if (mapReady && customerMarkers.length > 0) {
            setShouldRenderMarkers(true);
        }
    }, [mapReady, customerMarkers]);

    if (!center) {
        return (
            <div className={`w-full h-full flex items-center justify-center border-2 rounded-l-lg ${darkMode ? 'border-neutral-700' : ''}`}>
                <div className={`text-center flex flex-col justify-center items-center px-6 py-2`}>
                    <GlobeAmericasIcon className={`size-12`} />
                    <h3 className="mt-2 text-sm font-semibold">Error Loading Map</h3>
                    <p className="mt-1 text-sm text-gray-500">Check the Customer's Address!</p>
                </div>
            </div>
        );
    }
    
    const getSvgDataUri = (type, color = '#22c55e') => {
      let svgString;
    
      switch (type) {
        case 'Tank':
          svgString = `
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3 21.5C3 20.6667 4.8 19 12 19C15 19 21 19.5 21 21.5C21 22.3333 19.2 24 12 24C9 23.8333 3 23.1 3 21.5Z" fill="#166534"/>
                <path d="M4 9C4 6.33333 5.6 1 12 1C14.6667 1 20 2.6 20 9C20 16.8074 13.7029 21.7812 12.2824 22.8038C12.1121 22.9264 11.8935 22.9195 11.7306 22.7873C10.3358 21.6549 4 16.1194 4 9Z" fill="#16a34a"/>
                <path d="M7 14H7.5M17 14H16.5M16.5 14V13.25C16.5 13.1119 16.3881 13 16.25 13V13M16.5 14H7.5M7.5 14V13.5C7.5 13.2239 7.72386 13 8 13V13M8 13V5.80902C8 5.61963 8.107 5.4465 8.27639 5.3618L9.25 4.875M8 13H8.75M12 13V8M12 13H8.75M12 13H12.75M12 8L13 7.33333M12 8V6M15 13H16.25M15 13V12M15 13H12.75M9.25 4.875L9.77639 4.6118C9.91716 4.54142 10.0828 4.54142 10.2236 4.6118L10.75 4.875M9.25 4.875V4.25C9.25 3.97386 9.47386 3.75 9.75 3.75H10M10.75 4.875L11.7236 5.3618C11.893 5.4465 12 5.61963 12 5.80902V6M10.75 4.875V4.25C10.75 3.97386 10.5261 3.75 10.25 3.75H10M13 7.33333L13.2227 7.1849C13.3906 7.07293 13.6094 7.07293 13.7773 7.1849L14 7.33333M13 7.33333V6.75C13 6.47386 13.2239 6.25 13.5 6.25V6.25M14 7.33333L14.7774 7.85157C14.9164 7.9443 15 8.10042 15 8.26759V8.5M14 7.33333V6.75C14 6.47386 13.7761 6.25 13.5 6.25V6.25M13.5 6.25V3.5C13.5 3.22386 13.2761 3 13 3H10.5C10.2239 3 10 3.22386 10 3.5V3.75M16.25 8V9M16.25 13V12M16.25 12H15M16.25 12V11M15 12V11M15 11H16.25M15 11V10M16.25 11V10M16.25 10H15M16.25 10V9M15 10V9M15 9H16.25M15 9V8.5M12 6H9.25M15 8.5H13M8.75 13V7.5M12.75 13V9.5" stroke="white" stroke-width="0.5" stroke-linecap="round"/>
            </svg>
            `;
          break;
    
        case 'Field':
          svgString = `
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3 21.5C3 20.6667 4.8 19 12 19C15 19 21 19.5 21 21.5C21 22.3333 19.2 24 12 24C9 23.8333 3 23.1 3 21.5Z" fill="#166534"/>
                <path d="M4 9C4 6.33333 5.6 1 12 1C14.6667 1 20 2.6 20 9C20 16.8074 13.7029 21.7812 12.2824 22.8038C12.1121 22.9264 11.8935 22.9195 11.7306 22.7873C10.3358 21.6549 4 16.1194 4 9Z" fill="#16a34a"/>
                <circle cx="12" cy="9" r="5.75" stroke="white" stroke-width="0.5"/>
                <path d="M16.7969 6H16.5M8 6L8.53125 13.4688M8 6H9M8 6H7.25M11.75 6L12.0312 6.75L12.125 7M11.75 6H11M11.75 6H16.5M14.75 14L14.375 13M12.125 7L12.5 8M12.125 7H14.75M12.5 8H17.625M12.5 8L12.875 9M12.875 9H17.75M12.875 9L13.25 10M13.25 10H17.5M13.25 10L13.625 11M13.625 11L14 12M13.625 11H15.75M14 12H16.7969M14 12L14.375 13M14.375 13H16.0938M11 6L13.25 14.5938M11 6H10M10 6L11.5 14.6719M10 6H9M9 6L9.5 11.25M7.25 6V6C7.18444 6 7.16232 5.91243 7.22002 5.8813L9.20592 4.80996C9.31476 4.75125 9.4415 4.73495 9.56165 4.76422L10.3186 4.94861C10.4893 4.99019 10.6693 4.93915 10.7927 4.81417L11.3914 4.20801C11.6207 3.97583 12.0074 4.02199 12.1756 4.30162L12.5 4.84091M7.25 6V12.2188M12.875 5.25L12.5 4.84091M12.5 4.84091L13.3428 4.27396C13.5689 4.12184 13.8752 4.17883 14.0315 4.40209L14.4517 5.0025C14.5583 5.15469 14.7404 5.23527 14.9247 5.21175L15.1602 5.18168C15.288 5.16536 15.4172 5.19904 15.5208 5.27568L16.5 6M15.75 7H17.25M16.5 11H17.3438M9.75 12.5L10 14.3281" stroke="white" stroke-width="0.5" stroke-linecap="round"/>
            </svg>
          `;
          break;
    
        case 'Barn':
          svgString = `
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3 21.5C3 20.6667 4.8 19 12 19C15 19 21 19.5 21 21.5C21 22.3333 19.2 24 12 24C9 23.8333 3 23.1 3 21.5Z" fill="#166534"/>
                <path d="M4 9C4 6.33333 5.6 1 12 1C14.6667 1 20 2.6 20 9C20 16.8074 13.7029 21.7812 12.2824 22.8038C12.1121 22.9264 11.8935 22.9195 11.7306 22.7873C10.3358 21.6549 4 16.1194 4 9Z" fill="#16a34a"/>
                <path d="M7.5 8.31579V13.5C7.5 13.7761 7.72386 14 8 14H9M7.5 8.31579L8.40522 6.17185C8.46504 6.03016 8.58675 5.92389 8.73521 5.8837L11.8694 5.03536C11.9549 5.0122 12.0451 5.0122 12.1306 5.03536L15.2648 5.8837C15.4133 5.92389 15.535 6.03016 15.5948 6.17185L16.5 8.31579M7.5 8.31579L7 9.02632M16.5 8.31579V13.5C16.5 13.7761 16.2761 14 16 14H15M16.5 8.31579L17 9.02632M9 14V10.6842M9 14H12M9 14L12 10.6842M9 10.6842H12M9 10.6842L12 14M15 10.6842V14M15 10.6842H12M15 10.6842L12 14M15 14H12M15 14L12 10.6842M12 10.6842V14M11 6.18421H13M11 6.18421V9.02632M11 6.18421L13 9.02632M13 6.18421V9.02632M13 6.18421L11 9.02632M13 9.02632H11" stroke="white" stroke-width="0.5" stroke-linecap="round"/>
                <path d="M8 7V3.6C8 3.12 9 3 9.5 3C10.7 3 11 3.4 11 3.6V4.6M8.75 4H10.25M8.75 4.8H10.25" stroke="white" stroke-width="0.5" stroke-linecap="round"/>
            </svg>
            `;
          break;
    
        default:
          svgString = `
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3 21.5C3 20.6667 4.8 19 12 19C15 19 21 19.5 21 21.5C21 22.3333 19.2 24 12 24C9 23.8333 3 23.1 3 21.5Z" fill="#166534"/>
                <path d="M4 9C4 6.33333 5.6 1 12 1C14.6667 1 20 2.6 20 9C20 16.8074 13.7029 21.7812 12.2824 22.8038C12.1121 22.9264 11.8935 22.9195 11.7306 22.7873C10.3358 21.6549 4 16.1194 4 9Z" fill="#16a34a"/>
                <path d="M11.9142 12.0546C12.9672 12.5835 14.4657 11.8719 14.6053 11.7878C15.5226 11.2356 16.1545 9.83148 16.1545 9.20434V5.81529C16.1545 5.80013 16.1556 5.78492 16.1582 5.76998C16.2595 5.19254 16.6079 4.72406 16.7542 4.55267C16.7894 4.51149 16.8168 4.46309 16.8244 4.40947C16.8859 3.9713 16.5832 4.00493 16.4446 4.00493" stroke="white" stroke-width="0.5"/>
                <path d="M11.249 12.401C11.249 12.1555 11.4676 12.0481 11.5961 12.0073C11.6191 12 11.6432 11.9969 11.6673 11.9982C11.8152 12.0059 11.9335 12.0585 11.9797 12.0873" stroke="white" stroke-width="0.5"/>
                <path d="M8.75975 8.21216V15.7191C8.75975 15.8742 8.63397 16 8.47882 16H7.28093C7.12578 16 7 15.8742 7 15.7191V8.21216C7 4.93229 9.74571 4.03744 11.1186 4" stroke="white" stroke-width="0.5"/>
                <path d="M9.48985 8.21216V15.7191C9.48985 15.8742 9.61563 16 9.77078 16H10.9687C11.1238 16 11.2496 15.8742 11.2496 15.7191V12.3869" stroke="white" stroke-width="0.5"/>
                <path d="M12.1482 8.30577H13.4024C13.5575 8.30577 13.6833 8.18 13.6833 8.02484V6.82695C13.6833 6.6718 13.5575 6.54602 13.4024 6.54602H11.2683" stroke="white" stroke-width="0.5"/>
                <path d="M14.4134 9.14822V6.0594C14.4134 5.90425 14.2876 5.77847 14.1325 5.77847H11.2496" stroke="white" stroke-width="0.5"/>
                <path d="M11.0998 4H16.454" stroke="white" stroke-width="0.5"/>
                <path d="M8.75975 8.2496C8.75975 6.34758 10.4321 5.80343 11.2683 5.77847" stroke="white" stroke-width="0.5"/>
                <path d="M9.48985 8.26833C9.48985 6.95039 10.7005 6.57098 11.3057 6.54602" stroke="white" stroke-width="0.5"/>
                <path d="M12.1739 8.30577C11.4475 8.34321 11.2348 9.00157 11.2192 9.32605C11.2192 10.1647 11.8557 10.4118 12.1739 10.4306H13.4002C14.0905 10.4072 14.3884 9.55849 14.4134 9.12479" stroke="white" stroke-width="0.5"/>
            </svg>
            `;
      }
    
      return `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svgString)}`;
    };

    return (
        <div className={`rounded-lg h-[404px] overflow-hidden border-2 ${darkMode ? 'border-neutral-700' : ''}`}>
            
            <LoadScriptNext googleMapsApiKey="AIzaSyDxrbk0CKmZUpJ-5eQGaxHH-I5lYeWrPfc">
                <GoogleMap
                    key={center?.lat + ',' + center?.lng} // 👈 force re-render
                    mapContainerStyle={containerStyle}
                    center={center}
                    zoom={16}
                    options={{
                        mapTypeId: 'hybrid',
                        disableDefaultUI: true,
                    }}
                    onLoad={handleLoad}
                    onClick={handleMapClick}
                >
                    {/* Center marker */}
                    <Marker position={center}/>

                    {shouldRenderMarkers &&
                      customerMarkers.map((marker, idx) => {
                        console.log(`Rendering marker ${idx}:`, JSON.stringify(marker, null, 2));

                        if (
                          !marker.position ||
                          typeof marker.position.lat !== 'number' ||
                          typeof marker.position.lng !== 'number'
                        ) {
                          console.warn(`Skipping invalid marker at index ${idx}`, marker);
                          return null;
                        }

                        return (
                          <Marker
                            key={idx}
                            position={marker.position}
                            icon={{
                                url: getSvgDataUri(marker.type, '#22c55e'), // replace with your theme's currentColor
                                scaledSize: new window.google.maps.Size(48, 48),
                            }}
                            label={{
                                text: marker.label,
                                className: "text-xs bg-green-600 text-white p-1 rounded mt-20",
                            }}
                          />
                        );
                      })
                    }
                </GoogleMap>
            </LoadScriptNext>
            
            <Dialog open={dialogOpen} onClose={setDialogOpen} className="relative z-50">
                <DialogBackdrop
                    transition
                    className="fixed inset-0 bg-gray-500/50 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
                />
                
                <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                    <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                        <DialogPanel
                            transition
                            className={`relative transform overflow-hidden rounded-lg ${darkMode ? 'bg-darkMainColor text-white' : 'bg-white text-black'} px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-xl sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95`}
                        >
                            <div className="sm:flex sm:items-start">
                                <div
                                    className="mx-auto flex size-16 shrink-0 items-center justify-center rounded-full bg-green-600/15 sm:mx-0 sm:size-12">
                                    <TANK aria-hidden="true" className="size-8 text-green-600"/>
                                </div>
                                <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                                    <DialogTitle as="h3" className="text-base font-semibold">
                                        Customer Specific Locations
                                    </DialogTitle>
                                    <div className="mt-2">
                                        <p className="text-sm text-gray-500">
                                            This will add a custom location to the customer's account within the PFC sales tool system. You can use this in the order form to specify the locations for products to get delivered to.
                                        </p>
                                    </div>
                                    
                                    <div className="mt-4 grid grid-cols-2 gap-3">
                                        
                                        {/*Code*/}
                                        <div className={`relative col-span-full`}>
                                            <label
                                                htmlFor="code"
                                                className={`absolute -top-2 left-2 inline-block rounded-lg ${darkMode ? 'bg-darkMainColor' : 'bg-white text-gray-900'} px-1 text-xs font-medium`}
                                            >
                                                Location Label
                                            </label>
                                            <Input
                                                id="code"
                                                name="code"
                                                type="text"
                                                value={newMarkerLabel}
                                                onChange={(e) => setNewMarkerLabel(e.target.value)}
                                                placeholder={`Label`}
                                                className={`block w-full rounded-md ${darkMode ? 'bg-darkMainColor text-white outline-neutral-700' : 'bg-white text-gray-900 outline-gray-300'} px-3 py-2 text-base outline outline-1 -outline-offset-1 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-green-600 sm:text-sm/6`}
                                            />
                                        </div>
                                        
                                        {/*Location Type*/}
                                        <div className={`relative col-span-2`}>
                                            <label
                                                htmlFor="type"
                                                className={`absolute -top-2 left-2 inline-block rounded-lg ${darkMode ? 'bg-darkMainColor' : 'bg-white text-gray-900'} px-1 text-xs font-medium`}
                                            >
                                                Location Type
                                            </label>
                                            <Select
                                                id="type"
                                                name="type"
                                                value={newMarkerType}
                                                onChange={(e) => setNewMarkerType(e.target.value)}
                                                className={`block w-full rounded-md ${darkMode ? 'bg-darkMainColor text-white outline-neutral-700' : 'bg-white text-gray-900 outline-gray-300'} px-3 py-2 text-base outline outline-1 -outline-offset-1 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-green-600 sm:text-sm/6`}
                                            >
                                                <option value="Tank">Tank</option>
                                                <option value="Field">Field</option>
                                                <option value="Barn">Barn</option>
                                                <option value="Office">Office</option>
                                            </Select>
                                        </div>
                                        
                                        {/*Max*/}
                                        <div className={`relative col-span-1`}>
                                            <label
                                                htmlFor="max"
                                                className={`absolute -top-2 left-2 inline-block rounded-lg ${darkMode ? 'bg-darkMainColor' : 'bg-white text-gray-900'} px-1 text-xs font-medium`}
                                            >
                                                Maximum Capacity
                                            </label>
                                            <Input
                                                id="max"
                                                name="max"
                                                type="number"
                                                value={newMarkerMax}
                                                onChange={(e) => setNewMarkerMax(e.target.value)}
                                                placeholder={`Maximum`}
                                                className={`block w-full rounded-md ${darkMode ? 'bg-darkMainColor text-white outline-neutral-700' : 'bg-white text-gray-900 outline-gray-300'} px-3 py-2 text-base outline outline-1 -outline-offset-1 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-green-600 sm:text-sm/6`}
                                            />
                                        </div>
                                        
                                        {/*Unit*/}
                                        <div className={`relative col-span-1`}>
                                            <label
                                                htmlFor="unit"
                                                className={`absolute -top-2 left-2 inline-block rounded-lg ${darkMode ? 'bg-darkMainColor' : 'bg-white text-gray-900'} px-1 text-xs font-medium`}
                                            >
                                                Unit
                                            </label>
                                            <Select
                                                id="unit"
                                                name="unit"
                                                value={newMarkerUnit}
                                                onChange={(e) => setNewMarkerUnit(e.target.value)}
                                                className={`block w-full rounded-md ${darkMode ? 'bg-darkMainColor text-white outline-neutral-700' : 'bg-white text-gray-900 outline-gray-300'} px-3 py-2.5 text-base outline outline-1 -outline-offset-1 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-green-600 sm:text-sm/6`}
                                            >
                                                <option value="">Select a Unit...</option>
                                                <option value="gal">Gallon</option>
                                                <option value="lbs">Pounds</option>
                                                <option value="ton">Tons</option>
                                            </Select>
                                        </div>
                                    
                                    </div>
                                
                                
                                </div>
                            </div>
                            <div className="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
                                <Button
                                    type="button"
                                    onClick={handleSaveMarker}
                                    className="inline-flex w-full justify-center rounded-md bg-green-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-opacity-50 sm:ml-3 sm:w-auto"
                                >
                                    Save Location
                                </Button>
                                <Button
                                    type="button"
                                    data-autofocus
                                    onClick={() => setDialogOpen(false)}
                                    className={`mt-3 inline-flex w-full justify-center rounded-md ${darkMode ? 'bg-darkBgColor' : 'bg-white ring-1 ring-inset ring-gray-300'} px-3 py-2 text-sm font-semibold shadow-sm hover:bg-opacity-50 sm:mt-0 sm:w-auto`}
                                >
                                    Cancel
                                </Button>
                            </div>
                        </DialogPanel>
                    </div>
                </div>
            </Dialog>
            
        </div>
    );
};

export default SmallMap;
